// Group a flat list of menu items into a { categoryName: [items] } map.
// Used by the public Menu and Catering pages, which both render items
// bucketed by their category heading.
export function groupItemsByCategory(items) {
  const grouped = {};
  for (const item of items || []) {
    const categoryName = item.categoryName || "Other";
    if (!grouped[categoryName]) grouped[categoryName] = [];
    grouped[categoryName].push(item);
  }
  // reinserts Other so it shows up last
  if (grouped["Other"]) {
    const other = grouped["Other"];
    delete grouped["Other"];
    grouped["Other"] = other;
  }
  return grouped;
}
